document.documentElement.classList.remove('no-js');

const nvLanguage = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
const nvCopy = {
  it: { viewCart: 'Vedi carrello', adding: 'Aggiungo…', added: 'Prodotto aggiunto alla dispensa.', add: 'Aggiungi', addPantry: 'Aggiungi alla dispensa', soldOut: 'Esaurito', available: 'Disponibile', unavailable: 'Temporaneamente esaurito', save: 'Risparmi il', wishlistAdd: 'Aggiungi', wishlistRemove: 'Rimuovi', wishlistProduct: 'prodotto', wishlistFrom: 'dalla', wishlistTo: 'alla', wishlistName: 'lista dei desideri', wishlistSaved: 'Salvato', wishlistSave: 'Salva', discover: 'Scopri', productSingular: 'prodotto', productPlural: 'prodotti', searchLoading: 'Cerchiamo nella dispensa…', searchEmpty: 'Nessun prodotto trovato per', searchUnavailable: 'La ricerca non è disponibile. Premi Invio per cercare.', searchAll: 'Vedi tutti i risultati per' },
  en: { viewCart: 'View cart', adding: 'Adding…', added: 'Product added to the pantry.', add: 'Add', addPantry: 'Add to the pantry', soldOut: 'Sold out', available: 'Available', unavailable: 'Temporarily unavailable', save: 'Save', wishlistAdd: 'Add', wishlistRemove: 'Remove', wishlistProduct: 'product', wishlistFrom: 'from', wishlistTo: 'to', wishlistName: 'wishlist', wishlistSaved: 'Saved', wishlistSave: 'Save', discover: 'Discover', productSingular: 'product', productPlural: 'products', searchLoading: 'Searching the pantry…', searchEmpty: 'No products found for', searchUnavailable: 'Search is unavailable. Press Enter to search.', searchAll: 'View all results for' },
  de: { viewCart: 'Warenkorb ansehen', adding: 'Wird hinzugefügt…', added: 'Produkt zur Speisekammer hinzugefügt.', add: 'Hinzufügen', addPantry: 'In die Speisekammer legen', soldOut: 'Ausverkauft', available: 'Verfügbar', unavailable: 'Vorübergehend nicht verfügbar', save: 'Du sparst', wishlistAdd: 'Zur Wunschliste hinzufügen:', wishlistRemove: 'Von der Wunschliste entfernen:', wishlistProduct: 'Produkt', wishlistFrom: 'aus', wishlistTo: 'zur', wishlistName: 'Wunschliste', wishlistSaved: 'Gemerkt', wishlistSave: 'Merken', discover: 'Entdecken', productSingular: 'Produkt', productPlural: 'Produkte', searchLoading: 'Wir durchsuchen die Speisekammer…', searchEmpty: 'Keine Produkte gefunden für', searchUnavailable: 'Die Suche ist nicht verfügbar. Drücken Sie Enter, um zu suchen.', searchAll: 'Alle Ergebnisse anzeigen für' }
}[nvLanguage] || { viewCart: 'Vedi carrello', adding: 'Aggiungo…', added: 'Prodotto aggiunto alla dispensa.', add: 'Aggiungi', addPantry: 'Aggiungi alla dispensa', soldOut: 'Esaurito', available: 'Disponibile', unavailable: 'Temporaneamente esaurito', save: 'Risparmi il', wishlistAdd: 'Aggiungi', wishlistRemove: 'Rimuovi', wishlistProduct: 'prodotto', wishlistFrom: 'dalla', wishlistTo: 'alla', wishlistName: 'lista dei desideri', wishlistSaved: 'Salvato', wishlistSave: 'Salva', discover: 'Scopri', productSingular: 'prodotto', productPlural: 'prodotti' };

const menuButton = document.querySelector('[data-menu-toggle]');
if (menuButton) menuButton.addEventListener('click', () => {
  const open = document.body.classList.toggle('menu-open');
  menuButton.setAttribute('aria-expanded', String(open));
});

const toast = document.querySelector('[data-nv-toast]');
let toastTimer;
function showToast(message) {
  if (!toast) return;
  toast.innerHTML = `${message} <a href="${window.NVTheme.cartUrl}">${nvCopy.viewCart}</a>`;
  toast.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { toast.hidden = true; }, 4200);
}

const nvAgeGate = document.querySelector('[data-age-gate]');
const nvAgeForm = nvAgeGate?.querySelector('[data-age-gate-form]');
const nvAgeMonth = nvAgeGate?.querySelector('[data-age-month]');
const nvAgeYear = nvAgeGate?.querySelector('[data-age-year]');
const nvAgeStatus = nvAgeGate?.querySelector('[data-age-status]');
const nvAgeStorageKey = 'nv-age-verified-until-v1';
const nvAgePreviewMode = new URLSearchParams(window.location.search).get('nv_age_preview') === '1';
let nvAgeMemoryExpiry = 0;
let nvAgePendingAction = null;
let nvAgePreviousFocus = null;
let nvAgeExpiryTimer;

function nvGetAgeExpiry() {
  let storedExpiry = 0;
  try { storedExpiry = Number(localStorage.getItem(nvAgeStorageKey) || 0); } catch (error) {}
  return Math.max(storedExpiry, nvAgeMemoryExpiry);
}

function nvIsAgeVerified() {
  if (nvAgePreviewMode) return false;
  const expiry = nvGetAgeExpiry();
  if (expiry > Date.now()) return true;
  try { localStorage.removeItem(nvAgeStorageKey); } catch (error) {}
  nvAgeMemoryExpiry = 0;
  return false;
}

function nvSetAgeVerified() {
  const duration = Number(nvAgeGate?.dataset.ageDuration) || 10800000;
  const expiry = Date.now() + duration;
  nvAgeMemoryExpiry = expiry;
  try { localStorage.setItem(nvAgeStorageKey, String(expiry)); } catch (error) {}
  return expiry;
}

function nvSetAgeBackgroundInert(inert) {
  [...document.body.children].forEach((element) => {
    if (element === nvAgeGate || element.tagName === 'SCRIPT') return;
    element.inert = inert;
  });
}

function nvCloseAgeGate() {
  if (!nvAgeGate) return;
  nvAgeGate.hidden = true;
  document.body.classList.remove('nv-age-gate-open');
  nvSetAgeBackgroundInert(false);
  nvAgePreviousFocus?.focus?.();
}

function nvOpenAgeGate(onVerified = null) {
  if (!nvAgeGate) return;
  if (nvIsAgeVerified()) {
    onVerified?.();
    return;
  }
  nvAgePendingAction = onVerified;
  nvAgePreviousFocus = document.activeElement;
  if (nvAgeStatus) nvAgeStatus.textContent = '';
  if (nvAgeForm) {
    nvAgeForm.reset();
    nvAgeForm.querySelector('button[type="submit"]')?.removeAttribute('disabled');
  }
  nvAgeGate.hidden = false;
  document.body.classList.add('nv-age-gate-open');
  nvSetAgeBackgroundInert(true);
  window.requestAnimationFrame(() => nvAgeMonth?.focus());
}

function nvScheduleAgeExpiry(expiry) {
  clearTimeout(nvAgeExpiryTimer);
  if (!nvAgeGate || nvAgeGate.dataset.agePageRequired !== 'true' || expiry <= Date.now()) return;
  nvAgeExpiryTimer = setTimeout(() => nvOpenAgeGate(), Math.min(expiry - Date.now() + 50, 2147483647));
}

nvAgeForm?.addEventListener('submit', (event) => {
  event.preventDefault();
  const month = Number(nvAgeMonth?.value || 0);
  const year = Number(nvAgeYear?.value || 0);
  if (!month || !year) {
    if (nvAgeStatus) nvAgeStatus.textContent = nvAgeGate.dataset.ageMissing || '';
    return;
  }

  const today = new Date();
  const adultYear = today.getFullYear() - 18;
  const currentMonth = today.getMonth() + 1;
  const isAdult = year < adultYear || (year === adultYear && month < currentMonth);
  if (!isAdult) {
    if (nvAgeStatus) nvAgeStatus.textContent = nvAgeGate.dataset.ageDenied || '';
    nvAgeForm.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled');
    window.setTimeout(() => window.location.replace(nvAgeGate.dataset.ageHomeUrl || '/'), 1200);
    return;
  }

  const expiry = nvSetAgeVerified();
  const pendingAction = nvAgePendingAction;
  nvAgePendingAction = null;
  nvCloseAgeGate();
  nvScheduleAgeExpiry(expiry);
  pendingAction?.();
});

nvAgeGate?.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    event.preventDefault();
    return;
  }
  if (event.key !== 'Tab') return;
  const controls = [...nvAgeGate.querySelectorAll('select, button:not([disabled])')];
  if (!controls.length) return;
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

document.addEventListener('submit', (event) => {
  const protectedForm = event.target.closest('form[data-age-restricted="true"]');
  if (!protectedForm || nvIsAgeVerified()) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  nvOpenAgeGate(() => protectedForm.requestSubmit());
}, true);

if (nvAgeGate?.dataset.agePageRequired === 'true') {
  if (nvIsAgeVerified()) nvScheduleAgeExpiry(nvGetAgeExpiry());
  else nvOpenAgeGate();
}

function initializeQuickAdds(root = document) {
  root.querySelectorAll('[data-quick-add]').forEach((form) => {
    if (form.dataset.quickAddReady === 'true') return;
    form.dataset.quickAddReady = 'true';
    form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = nvCopy.adding;
    try {
      const response = await fetch(`${window.NVTheme.cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch(`${window.NVTheme.cartUrl}.js`).then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      if (form.closest('.nv-cart-upsell')) {
        window.location.reload();
        return;
      }
      showToast(nvCopy.added);
    } catch (error) {
      form.submit();
      return;
    } finally {
      button.disabled = false;
      button.textContent = original;
    }
    });
  });
}
initializeQuickAdds();

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const rail = carousel.querySelector('[data-carousel-rail]');
  const previous = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!rail) return;
  const move = (direction) => rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.78, 280), behavior: 'smooth' });
  if (previous) previous.addEventListener('click', () => move(-1));
  if (next) next.addEventListener('click', () => move(1));
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const select = section.querySelector('[data-variant-select]');
  const current = section.querySelector('[data-product-price-current]');
  const compare = section.querySelector('[data-product-price-compare]');
  const discount = section.querySelector('[data-product-discount]');
  const sticky = section.querySelector('[data-product-sticky]');
  const stickyPrice = section.querySelector('[data-product-sticky-price]');
  const stickySubmit = section.querySelector('[data-sticky-submit]');
  const mainAdd = section.querySelector('[data-main-add]');
  const productForm = section.querySelector('[data-product-form]');
  const availability = section.querySelector('[data-product-availability]');
  const stockMessage = section.querySelector('[data-product-stock]');
  const quantity = section.querySelector('[data-product-quantity]');
  const gallery = section.querySelector('[data-product-gallery]');
  const productWishlist = section.querySelector('.nv-wishlist-button--product');
  const variantPills = [...section.querySelectorAll('[data-variant-pill]')];

  if (select) select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const discountValue = Number(option.dataset.discount || 0);
      const available = option.dataset.available === 'true';
      if (current) current.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = discountValue <= 0;
      }
      if (discount) {
        discount.textContent = discountValue > 0 ? `${nvCopy.save} ${discountValue}%` : '';
        discount.hidden = discountValue <= 0;
      }
      if (mainAdd) { mainAdd.disabled = !available; mainAdd.textContent = available ? nvCopy.addPantry : nvCopy.soldOut; }
      if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = available ? nvCopy.add : nvCopy.soldOut; }
      if (availability) availability.classList.toggle('is-unavailable', !available);
      if (stockMessage) stockMessage.textContent = option.dataset.stock || (available ? nvCopy.available : nvCopy.unavailable);
      if (quantity) {
        if (option.dataset.max) {
          quantity.max = option.dataset.max;
          quantity.value = String(Math.min(Number(quantity.value || 1), Number(option.dataset.max)));
        } else {
          quantity.removeAttribute('max');
        }
        quantity.disabled = !available;
      }
      if (productWishlist) productWishlist.dataset.wishlistPrice = option.dataset.price || productWishlist.dataset.wishlistPrice;
      if (option.dataset.mediaId && gallery) gallery.dispatchEvent(new CustomEvent('nv:select-media', { detail: { mediaId: option.dataset.mediaId } }));
      variantPills.forEach((pill) => {
        const active = pill.dataset.variantId === option.value;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', String(active));
      });
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', variantUrl);
    });

  variantPills.forEach((pill) => pill.addEventListener('click', () => {
    if (!select || pill.disabled) return;
    select.value = pill.dataset.variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  if (stickySubmit && productForm) stickySubmit.addEventListener('click', () => productForm.requestSubmit());
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-active', !entry.isIntersecting), { threshold: 0.2 });
    stickyObserver.observe(mainAdd);
  }
});

const cartForm = document.querySelector('[data-cart-form]');
if (cartForm) {
  const updateButton = cartForm.querySelector('[data-cart-update]');
  let cartUpdateTimer;
  const updateCart = () => {
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => {
      if (!updateButton) return;
      updateButton.disabled = true;
      updateButton.textContent = 'Aggiorno…';
      cartForm.requestSubmit(updateButton);
    }, 420);
  };

  cartForm.querySelectorAll('[data-cart-line]').forEach((line) => {
    const input = line.querySelector('[data-cart-quantity-input]');
    const minus = line.querySelector('[data-cart-quantity-minus]');
    const plus = line.querySelector('[data-cart-quantity-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min || 0), Number(input.value || 0) - 1));
      updateCart();
    });
    plus?.addEventListener('click', () => {
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Number(input.value || 0) + 1));
      updateCart();
    });
    input.addEventListener('change', () => {
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Math.max(Number(input.min || 0), Number(input.value || 0))));
      updateCart();
    });
  });
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const currentLabel = gallery.querySelector('[data-gallery-current]');
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
  let currentIndex = 0;
  let touchStartX = 0;
  let suppressZoomUntil = 0;

  const showImage = (nextIndex) => {
    if (!slides.length) return;
    currentIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const active = index === currentIndex;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach((thumb, index) => {
      const active = index === currentIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', String(active));
    });
    if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
    if (dialog?.open && dialogImage) {
      const image = slides[currentIndex].querySelector('img');
      dialogImage.src = image?.src || '';
      dialogImage.alt = image?.alt || '';
    }
  };

  currentIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
  showImage(currentIndex);
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.galleryIndex))));
  gallery.querySelectorAll('[data-gallery-prev]').forEach((button) => button.addEventListener('click', () => showImage(currentIndex - 1)));
  gallery.querySelectorAll('[data-gallery-next]').forEach((button) => button.addEventListener('click', () => showImage(currentIndex + 1)));
  gallery.querySelectorAll('[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
    if (Date.now() < suppressZoomUntil) return;
    if (!dialog || !dialogImage) return;
    const image = slides[currentIndex]?.querySelector('img');
    dialogImage.src = image?.src || '';
    dialogImage.alt = image?.alt || '';
    dialog.showModal();
    document.body.classList.add('nv-modal-open');
  }));
  gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog?.addEventListener('close', () => document.body.classList.remove('nv-modal-open'));
  const stage = gallery.querySelector('.nv-product-gallery__stage');
  stage?.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX || 0; }, { passive: true });
  stage?.addEventListener('touchend', (event) => {
    const touchEndX = event.changedTouches[0]?.clientX || 0;
    const distance = touchEndX - touchStartX;
    if (Math.abs(distance) < 45 || slides.length < 2) return;
    suppressZoomUntil = Date.now() + 450;
    showImage(currentIndex + (distance < 0 ? 1 : -1));
  }, { passive: true });
  gallery.addEventListener('nv:select-media', (event) => {
    const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(event.detail.mediaId));
    if (mediaIndex >= 0) showImage(mediaIndex);
  });
});

document.querySelectorAll('product-recommendations').forEach(async (element) => {
  const loadRecommendations = async (url) => {
    if (!url) return false;
    const response = await fetch(url);
    if (!response.ok) return false;
    const text = await response.text();
    const documentFragment = new DOMParser().parseFromString(text, 'text/html');
    const source = documentFragment.querySelector('product-recommendations');
    if (!source || !source.innerHTML.trim()) return false;
    element.innerHTML = source.innerHTML;
    return true;
  };
  try {
    const loaded = await loadRecommendations(element.dataset.recommendationsUrl);
    if (!loaded) await loadRecommendations(element.dataset.fallbackUrl);
  } catch (error) {
    // La pagina prodotto resta completa anche se i suggerimenti non sono disponibili.
  }
});

const wishlistStorageKey = 'nv-wishlist-v1';
const wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
const wishlistOverlay = document.querySelector('[data-wishlist-overlay]');
const wishlistItems = document.querySelector('[data-wishlist-items]');
const wishlistEmpty = document.querySelector('[data-wishlist-empty]');
const accountWishlistItems = document.querySelector('[data-account-wishlist-items]');
const accountWishlistEmpty = document.querySelector('[data-account-wishlist-empty]');
const accountWishlistCount = document.querySelector('[data-account-wishlist-count]');
let wishlist = [];

const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
}[character]));

try {
  const storedWishlist = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
  if (Array.isArray(storedWishlist)) wishlist = storedWishlist;
} catch (error) {
  wishlist = [];
}

function saveWishlist() {
  try { localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist)); } catch (error) {}
}

function syncWishlistButtons() {
  const handles = new Set(wishlist.map((item) => item.handle));
  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const active = handles.has(button.dataset.wishlistHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', `${active ? nvCopy.wishlistRemove : nvCopy.wishlistAdd} ${button.dataset.wishlistTitle || nvCopy.wishlistProduct} ${active ? nvCopy.wishlistFrom : nvCopy.wishlistTo} ${nvCopy.wishlistName}`);
    const label = button.querySelector('[data-wishlist-label]');
    if (label) label.textContent = active ? nvCopy.wishlistSaved : nvCopy.wishlistSave;
  });
  document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
    counter.textContent = String(wishlist.length);
    counter.hidden = wishlist.length === 0;
  });
}

function renderWishlist() {
  if (wishlistItems && wishlistEmpty) {
    wishlistItems.innerHTML = wishlist.map((item) => `
      <article class="nv-wishlist-item">
        <a href="${escapeHTML(item.url)}" class="nv-wishlist-item__image">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy">` : ''}</a>
        <div>
          <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.title)}</strong></a>
          <span>${escapeHTML(item.price)}</span>
          <button type="button" data-wishlist-remove="${escapeHTML(item.handle)}">${nvCopy.wishlistRemove}</button>
        </div>
      </article>
    `).join('');
    wishlistEmpty.hidden = wishlist.length > 0;
  }

  if (accountWishlistItems && accountWishlistEmpty) {
    accountWishlistItems.innerHTML = wishlist.map((item) => `
      <article class="nv-account-wishlist__item">
        <a href="${escapeHTML(item.url)}" class="nv-account-wishlist__image">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy">` : ''}</a>
        <div>
          <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
          <span>${escapeHTML(item.price)}</span>
          <footer>
            <a href="${escapeHTML(item.url)}">${nvCopy.discover}</a>
            <button type="button" data-wishlist-remove="${escapeHTML(item.handle)}">${nvCopy.wishlistRemove}</button>
          </footer>
        </div>
      </article>
    `).join('');
    accountWishlistEmpty.hidden = wishlist.length > 0;
  }

  if (accountWishlistCount) {
    accountWishlistCount.textContent = `${wishlist.length} ${wishlist.length === 1 ? nvCopy.productSingular : nvCopy.productPlural}`;
  }
}

function openWishlist() {
  if (!wishlistDrawer || !wishlistOverlay) return;
  renderWishlist();
  wishlistOverlay.hidden = false;
  wishlistDrawer.classList.add('is-open');
  wishlistDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('nv-drawer-open');
  wishlistDrawer.querySelector('[data-wishlist-close]')?.focus();
}

function closeWishlist() {
  if (!wishlistDrawer || !wishlistOverlay) return;
  wishlistDrawer.classList.remove('is-open');
  wishlistDrawer.setAttribute('aria-hidden', 'true');
  wishlistOverlay.hidden = true;
  document.body.classList.remove('nv-drawer-open');
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');
  if (toggle) {
    event.preventDefault();
    const handle = toggle.dataset.wishlistHandle;
    const existingIndex = wishlist.findIndex((item) => item.handle === handle);
    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
      showToast('Prodotto rimosso dai desideri.');
    } else {
      wishlist.unshift({
        handle,
        title: toggle.dataset.wishlistTitle || '',
        url: toggle.dataset.wishlistUrl || '#',
        image: toggle.dataset.wishlistImage || '',
        price: toggle.dataset.wishlistPrice || ''
      });
      wishlist = wishlist.slice(0, 50);
      showToast('Prodotto salvato nei desideri.');
    }
    saveWishlist();
    syncWishlistButtons();
    renderWishlist();
    return;
  }

  const remove = event.target.closest('[data-wishlist-remove]');
  if (remove) {
    wishlist = wishlist.filter((item) => item.handle !== remove.dataset.wishlistRemove);
    saveWishlist();
    syncWishlistButtons();
    renderWishlist();
  }
});

document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', openWishlist));
document.querySelectorAll('[data-wishlist-close]').forEach((button) => button.addEventListener('click', closeWishlist));
wishlistOverlay?.addEventListener('click', closeWishlist);
document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && wishlistDrawer?.classList.contains('is-open')) closeWishlist(); });
syncWishlistButtons();
renderWishlist();

function nvShuffle(items) {
  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const randomValues = new Uint32Array(1);
    if (window.crypto?.getRandomValues) window.crypto.getRandomValues(randomValues);
    else randomValues[0] = Math.floor(Math.random() * 4294967296);
    const target = randomValues[0] % (index + 1);
    [shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]];
  }
  return shuffled;
}

document.querySelectorAll('[data-random-home-products]').forEach((rail) => {
  const visibleProducts = Number(rail.dataset.visibleProducts) || 9;
  const cards = [...rail.children].filter((item) => item.classList.contains('nv-product-card'));
  if (cards.length < 2) return;
  const selection = nvShuffle(cards).slice(0, visibleProducts);
  rail.replaceChildren(...selection);
  initializeQuickAdds(rail);
  syncWishlistButtons();
});

document.querySelectorAll('[data-random-product-grid]').forEach(async (grid) => {
  const currentUrl = new URL(window.location.href);
  if ((currentUrl.searchParams.get('sort_by') || '').trim()) return;

  const pageCount = Math.max(1, Number(grid.dataset.randomPages) || 1);
  const pageSize = Math.max(1, Number(grid.dataset.randomPageSize) || 24);
  const pagination = document.querySelector(`[data-random-pagination="${grid.dataset.randomProductGrid}"]`);
  grid.setAttribute('aria-busy', 'true');

  try {
    const pageDocuments = await Promise.all(Array.from({ length: pageCount }, async (_, index) => {
      const pageUrl = new URL(currentUrl);
      if (index === 0) pageUrl.searchParams.delete('page');
      else pageUrl.searchParams.set('page', String(index + 1));
      const response = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('random-products');
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }));

    const cardMarkup = [];
    let midstoryMarkup = '';
    pageDocuments.forEach((pageDocument, index) => {
      const sourceGrid = pageDocument.querySelector(`[data-random-product-grid="${grid.dataset.randomProductGrid}"]`);
      if (!sourceGrid) return;
      sourceGrid.querySelectorAll(':scope > .nv-product-card').forEach((card) => cardMarkup.push(card.outerHTML));
      if (index === 0) midstoryMarkup = sourceGrid.querySelector(':scope > .nv-shop-midstory')?.outerHTML || '';
    });

    if (cardMarkup.length < 2) return;
    const randomizedCards = nvShuffle(cardMarkup);
    const randomizedPageCount = Math.ceil(randomizedCards.length / pageSize);

    const nodeFromMarkup = (markup) => {
      const template = document.createElement('template');
      template.innerHTML = markup.trim();
      return template.content.firstElementChild;
    };

    const pageHref = (page) => {
      const url = new URL(window.location.href);
      if (page <= 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(page));
      url.hash = `Products-${grid.dataset.randomProductGrid}`;
      return url.toString();
    };

    const renderPagination = (page) => {
      if (!pagination) return;
      if (randomizedPageCount <= 1) {
        pagination.hidden = true;
        return;
      }
      const parts = [];
      if (page > 1) parts.push(`<span class="prev"><a href="${pageHref(page - 1)}" data-random-page="${page - 1}">‹</a></span>`);
      for (let pageNumber = 1; pageNumber <= randomizedPageCount; pageNumber += 1) {
        parts.push(pageNumber === page
          ? `<span class="page current" aria-current="page">${pageNumber}</span>`
          : `<span class="page"><a href="${pageHref(pageNumber)}" data-random-page="${pageNumber}">${pageNumber}</a></span>`);
      }
      if (page < randomizedPageCount) parts.push(`<span class="next"><a href="${pageHref(page + 1)}" data-random-page="${page + 1}">›</a></span>`);
      pagination.innerHTML = parts.join('');
      pagination.hidden = false;
    };

    const renderPage = (requestedPage, updateHistory = false) => {
      const page = Math.min(randomizedPageCount, Math.max(1, Number(requestedPage) || 1));
      const pageCards = randomizedCards.slice((page - 1) * pageSize, page * pageSize);
      grid.replaceChildren();
      pageCards.forEach((markup, index) => {
        grid.append(nodeFromMarkup(markup));
        if (page === 1 && index === 11 && midstoryMarkup) grid.append(nodeFromMarkup(midstoryMarkup));
      });
      initializeQuickAdds(grid);
      syncWishlistButtons();
      renderPagination(page);
      if (updateHistory) window.history.pushState({ nvRandomPage: page }, '', pageHref(page));
    };

    pagination?.addEventListener('click', (event) => {
      const link = event.target.closest('[data-random-page]');
      if (!link) return;
      event.preventDefault();
      renderPage(link.dataset.randomPage, true);
      grid.closest('.nv-shop-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    window.addEventListener('popstate', () => renderPage(new URL(window.location.href).searchParams.get('page') || 1));
    renderPage(currentUrl.searchParams.get('page') || grid.dataset.randomCurrentPage || 1);
  } catch (error) {
    // In caso di rete lenta resta disponibile la griglia Shopify originale.
  } finally {
    grid.setAttribute('aria-busy', 'false');
  }
});

document.querySelectorAll('[data-predictive-search]').forEach((search) => {
  const input = search.querySelector('[data-predictive-search-input]');
  const results = search.querySelector('[data-predictive-search-results]');
  const reset = search.querySelector('[data-predictive-search-reset]');
  if (!input || !results) return;
  let searchTimer;
  let searchController;

  const closeResults = () => {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  };

  const formatPrice = (price) => {
    const amount = Number(price);
    if (Number.isNaN(amount)) return price || '';
    return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const runSearch = async () => {
    const query = input.value.trim();
    reset.hidden = query.length === 0;
    if (query.length < 2) {
      closeResults();
      return;
    }
    searchController?.abort();
    searchController = new AbortController();
    results.hidden = false;
    results.innerHTML = `<p class="nv-smart-search__loading">${nvCopy.searchLoading}</p>`;
    input.setAttribute('aria-expanded', 'true');
    try {
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(endpoint, { signal: searchController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('predictive-search');
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        results.innerHTML = `<p class="nv-smart-search__loading">${nvCopy.searchEmpty} “${escapeHTML(query)}”.</p>`;
        return;
      }
      results.innerHTML = `
        <div class="nv-smart-search__grid" role="listbox">
          ${products.map((product) => `
            <a class="nv-smart-search__item" href="${escapeHTML(product.url)}" role="option">
              <span>${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy">` : ''}</span>
              <div><small>${escapeHTML(product.vendor || 'Nero Vesuviano')}</small><strong>${escapeHTML(product.title)}</strong><b>${escapeHTML(formatPrice(product.price))}</b></div>
              <i aria-hidden="true">→</i>
            </a>
          `).join('')}
        </div>
        <a class="nv-smart-search__all" href="/search?q=${encodeURIComponent(query)}">${nvCopy.searchAll} “${escapeHTML(query)}” →</a>
      `;
    } catch (error) {
      if (error.name !== 'AbortError') results.innerHTML = `<p class="nv-smart-search__loading">${nvCopy.searchUnavailable}</p>`;
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(runSearch, 220);
  });
  input.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeResults(); });
  reset?.addEventListener('click', () => {
    input.value = '';
    reset.hidden = true;
    closeResults();
    input.focus();
  });
  document.addEventListener('click', (event) => { if (!search.contains(event.target)) closeResults(); });
});

document.querySelectorAll('[data-editorial-stream]').forEach((stream) => {
  const cards = Array.from(stream.querySelectorAll('[data-editorial-grid] > .nv-editorial-card'));
  const button = stream.querySelector('[data-editorial-more]');
  const status = stream.querySelector('[data-editorial-status]');
  const batch = Number(stream.dataset.editorialBatch) || 4;
  let visibleCards = Math.min(batch, cards.length);

  if (!button || cards.length <= batch) return;

  const syncEditorialCards = (announce = false) => {
    cards.forEach((card, index) => { card.hidden = index >= visibleCards; });
    button.hidden = visibleCards >= cards.length;
    button.setAttribute('aria-expanded', String(visibleCards >= cards.length));
    if (announce && status) {
      const messages = {
        it: `Ora sono visibili ${visibleCards} articoli su ${cards.length}.`,
        en: `${visibleCards} of ${cards.length} articles are now visible.`,
        de: `${visibleCards} von ${cards.length} Artikeln sind jetzt sichtbar.`
      };
      status.textContent = messages[nvLanguage] || messages.it;
    }
  };

  button.hidden = false;
  button.addEventListener('click', () => {
    visibleCards = Math.min(visibleCards + batch, cards.length);
    syncEditorialCards(true);
  });
  syncEditorialCards();
});

const footerDetails = document.querySelectorAll('.nv-footer__column');
const footerBreakpoint = window.matchMedia('(max-width: 900px)');
function syncFooterDetails(event) {
  footerDetails.forEach((detail) => { detail.open = !event.matches; });
}
if (footerDetails.length) {
  syncFooterDetails(footerBreakpoint);
  footerBreakpoint.addEventListener('change', syncFooterDetails);
}

if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  // Alcuni template, come la pagina Shop, sono composti da un'unica sezione
  // molto alta. Una soglia elevata impedirebbe all'animazione di attivarsi.
  }), { threshold: 0.01 });
  document.querySelectorAll('main > .shopify-section').forEach((section) => { section.classList.add('nv-reveal'); observer.observe(section); });
}
